import Vue from 'vue';
import { assign } from 'lodash';
import * as api from 'api/api-allergens';
import * as types from '../mutation-types';

const initState = {
  ready: false,
  fetching: false,
  fetched: true,
  saving: false,
  deletion: false,
  saveError: null,
  error: null,
  notFound: null,
  meta: {},
  data: {},
};

const neutralState = {
  fetching: false,
  fetched: true,
  saving: false,
  deletion: false,
  saveError: null,
  error: null,
  notFound: null,
};

const state = {};

const getters = {
  AllergenDetails: state => id => state[id],
};

const actions = {
  GetAllergenDetails({ commit }, params) {
    const id = params.id;

    commit(types.FETCH_ALLERGEN_DETAILS_START, { id });
    api.getAllergenDetails(
      id,
      (response) => {
        commit(types.RECEIVE_ALLERGEN_DETAILS, { id, response });
      },
      (description, status, error) => {
        if (status === 404) {
          commit(types.FETCH_ALLERGEN_DETAILS_NOT_FOUND, { id, error });
        } else {
          commit(types.FETCH_ALLERGEN_DETAILS_ERROR, { id, error });
        }
      },
    );
  },
  InitAllergenDetails({ commit }, params) {
    const id = params.id;
    commit(types.CLEAR_ALLERGEN_DETAILS_STORE, { id });
  },
  AddAllergen({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      const id = params.id;
      const payload = params.payload;

      commit(types.ADD_ALLERGEN_START, { id });
      console.log('save data', params);
      api.addAllergen(
        payload,
        (response) => {
          console.log('save');
          commit(types.ADD_ALLERGEN_SUCCESSFUL, { id, response });
          dispatch('AddAllergenToAllergensList', response);
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.ADD_ALLERGEN_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  SaveAllergenDetails({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      const id = params.id;
      const payload = params.payload;

      commit(types.SAVE_ALLERGEN_DETAILS_START, { id });
      console.log('resend person', params);
      api.saveDetails(
        id,
        payload,
        (response) => {
          commit(types.SAVE_ALLERGEN_DETAILS_SUCCESSFUL, { id });
          dispatch('UpdateAllergenInAllergensList', response);
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.SAVE_ALLERGEN_DETAILS_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  DeleteAllergen({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      const id = params.id;

      commit(types.DELETE_ALLERGEN_START, { id });
      console.log('delete person', params);
      api.deleteAllergen(
        id,
        () => {
          commit(types.DELETE_ALLERGEN_SUCCESSFUL, { id });
          dispatch('RemoveAllergenFromAllergensList', id);
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.DELETE_ALLERGEN_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  ClearAllergenDetails({ commit }, { id }) {
    commit(types.CLEAR_ALLERGEN_DETAILS_STORE, { id });
  },
};

const mutations = {
  [types.FETCH_ALLERGEN_DETAILS_START](state, { id }) {
    if (state[id]) Vue.set(state, id, assign(state[id], neutralState, { fetching: true }));
    else Vue.set(state, id, assign({}, initState, { fetching: true }));
  },
  [types.FETCH_ALLERGEN_DETAILS_ERROR](state, { id, error }) {
    Vue.set(state, id, assign(state[id], neutralState, { error }));
  },
  [types.FETCH_ALLERGEN_DETAILS_NOT_FOUND](state, { id }) {
    Vue.set(state, id, assign({}, neutralState, { notFound: true }));
  },
  [types.RECEIVE_ALLERGEN_DETAILS](state, { id, response }) {
    Vue.set(state, id, assign(state[id], neutralState, { ready: true, data: response.data, meta: response.meta }));
  },

  [types.CLEAR_ALLERGEN_DETAILS_STORE](state, { id }) {
    Vue.set(state, id, assign({}, initState));
  },

  [types.ADD_ALLERGEN_START](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState, { saving: true }));
  },
  [types.ADD_ALLERGEN_ERROR](state, { id, saveError }) {
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },
  [types.ADD_ALLERGEN_SUCCESSFUL](state, { id, response }) {
    Vue.set(state, id, assign(state[id], neutralState, { data: response.data, meta: response.meta }));
  },


  [types.DELETE_ALLERGEN_START](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState, { deletion: true }));
  },
  [types.DELETE_ALLERGEN_ERROR](state, { id, saveError }) {
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },
  [types.DELETE_ALLERGEN_SUCCESSFUL](state, { id }) {
    Vue.set(state, id, assign({}, initState));
  },

  [types.SAVE_ALLERGEN_DETAILS_START](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState, { saving: true }));
  },
  [types.SAVE_ALLERGEN_DETAILS_ERROR](state, { id, saveError }) {
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },
  [types.SAVE_ALLERGEN_DETAILS_SUCCESSFUL](state, { id }) {
    Vue.set(state, id, assign({}, initState));
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/workspace/entities/allergen-details.js